<!--We support 3 levels of subitems nesting for now-->

<ng-container *ngIf="menuService.getVerticalMenuItems | async as menu">
    <div class="content-front">
        <div style="padding: 20px;">
            <div class='item'>
                <div class='sidebar-header'>
                    {{menu?.title}}
                </div>
            </div>
            <div class='item'>
                <div class='menu'>
                    <ul>
                        <ng-template ngFor let-sidebarItem [ngForOf]="menu?.items">
                            <li class="category-item-li">
                                <div class="category-item">
                                    <a routerLinkActive='active' [routerLinkActiveOptions]="{exact:true}"
                                        routerLink='{{sidebarItem?.url}}'
                                        class="submenu-category-item">{{sidebarItem.translatedName ? sidebarItem.translatedName : sidebarItem.name}}</a>
                                </div>
                            </li>
                            <ng-template [ngIf]="sidebarItem?.subMenuItems">
                                <ng-template ngFor let-submenuItem [ngForOf]="sidebarItem.subMenuItems">
                                    <li class="submenu-item">
                                        <a routerLinkActive='active-sublink'
                                            routerLink='{{sidebarItem.url}}{{submenuItem?.url}}'
                                            class="submenu-category-item">
                                            {{submenuItem.translatedName ? submenuItem.translatedName : submenuItem.name}}
                                        </a>
                                    </li>
                                    <ng-template [ngIf]="submenuItem?.subMenuItems">
                                        <ul class="sub-sub-menu">
                                            <li class="submenu-item"
                                                *ngFor="let subSubmenuItem of submenuItem.subMenuItems,let isubsub = index">
                                                <a routerLinkActive='active-sublink' class="submenu-category-item"
                                                    routerLink='{{sidebarItem.url}}{{submenuItem?.url}}{{subSubmenuItem.url}}'>
                                                    {{subSubmenuItem.translatedName ? subSubmenuItem.translatedName : subSubmenuItem.name}}
                                                </a>
                                            </li>
                                        </ul>
                                    </ng-template>
                                </ng-template>
                            </ng-template>
                        </ng-template>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</ng-container>